import React from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import CustomControl from '../CustomControl/CustomControl';
import Icon from '../Icon/Icon';
import { EyeCheckbox } from '../CustomControl/CustomControlNew';

const DragHandle = SortableHandle(() => (
  <span className="item-drag-handler-new">
    <div type="drag" className="item-drag-handler-new" />
  </span>
));

const DashboardSettingsSectionItemNew = ({ index, ...props }) => {
  const SortableItem = SortableElement(({ id, title, enabled, section, onChange }) => (
    <li className={cn('dashboard-settings-item', { disabled: !enabled })}>
      <DragHandle />
      <EyeCheckbox
        id={`section-item-${id}`}
        // className="custom-control-xs"
        name={section}
        label={
          <FormattedMessage
            id={`widgets.dashboard-settings.item.${title}`}
            defaultMessage={title}
          />
        }
        value={id}
        checked={enabled}
        onChange={onChange}
      />
    </li>
  ));

  return <SortableItem index={index} {...props} />;
};

export default DashboardSettingsSectionItemNew;
